import { render } from "./NavLink.vue?vue&type=template&id=16279562&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=16279562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16279562"]])

export default __exports__